export default __webpack_public_path__ + "static/media/comment_3.7059e46e.png";